"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubscriptionUserHeader = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _hooks = require("../../hooks");
var _ToggleIcon = require("./ToggleIcon");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')({
    alignItems: 'center',
    borderBottom: "2px solid ".concat(_mui.theme.palette.grey[100]),
    cursor: 'pointer',
    display: 'flex',
    height: 20,
    padding: _mui.theme.spacing(3, 3, 2),
    position: 'relative',
    [_mui.theme.breakpoints.up('sm')]: {
        padding: _mui.theme.spacing(3, 6, 2)
    }
});
const Icon = (0, _mui.styled)(_ToggleIcon.ToggleIcon)({
    marginLeft: _mui.theme.spacing(1),
    position: 'absolute',
    right: _mui.theme.spacing(3),
    [_mui.theme.breakpoints.up('md')]: {
        position: 'static'
    }
});
const SubscriptionUserHeader = (param)=>{
    let { customerName, handleToggle, isExpanded, packageAmount } = param;
    const { formatMessage } = (0, _hooks.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        onClick: handleToggle,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                variant: "body1",
                children: customerName
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Typography, {
                marginLeft: _mui.theme.spacing(1),
                variant: "body1",
                children: [
                    "(",
                    packageAmount,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                color: "default",
                ownerState: {
                    isOpen: isExpanded
                },
                variant: "text",
                "aria-label": isExpanded ? formatMessage('closeList') : formatMessage('openList'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
                    fontSize: "inherit"
                })
            })
        ]
    });
};
exports.SubscriptionUserHeader = SubscriptionUserHeader;
